import Grid from "@mui/material/Grid";
import React, { useState, useEffect, useContext } from "react";
import { ValidatorForm } from 'react-material-ui-form-validator';
import CircularProgress from "@mui/material/CircularProgress";
import ChallengeQuestionForm from "./ChallengeQuestionForm";
import { APIContext } from "src/components/Contexts/APIContext"
import QaiChallengeViewModel from "./ViewModels/QaiChallengeViewModel";
import QaiScorecardViewModel from "./ViewModels/QaiScorecardViewModel";
import UserType from "../../Utilities/UserType";

interface IChallengeQuestionContainerProps {
    view: UserType
    setOpenChallengeDialog: (value: boolean) => void;
}

export default function ChallengeQuestionContainer({ view, setOpenChallengeDialog }: IChallengeQuestionContainerProps) {
    const { get, post, showMessage } = useContext(APIContext);
    const [loading, setLoading] = useState(true);
    const [challengeViewModel, setChallengeViewModel] = useState<QaiChallengeViewModel>(new QaiChallengeViewModel());
    const [scorecardViewModel, setScorecardViewModel] = useState<QaiScorecardViewModel | null>(null);

    useEffect(() => {
        setLoading(true)

        get('QaiScorecardChallenge', getScorecards(),
            (data) => {
                setScorecardViewModel(data);
            })
        setLoading(false);
    }, [])

    useEffect(() => {
        if (scorecardViewModel != null) {
            if (scorecardViewModel.templates.length === 1)
                setChallengeViewModel({
                    ...challengeViewModel,
                    templateId: scorecardViewModel.templates[0].id
                })
            setLoading(false);
        }
    }, [scorecardViewModel])

    const getScorecards = () => {
        switch (view) {
            case UserType.Agent:
                return 'GetScorecard'
            case UserType.TeamLeader:
                return 'GetScorecards'
            default:
                throw new Error('The UserType provided is not supported by this component');
        }
    }

    const handleSubmit = () => {
        post('QaiScorecardChallenge',
            'CreateChallenge',
            challengeViewModel,
            () => {
                setChallengeViewModel(new QaiChallengeViewModel());
                setOpenChallengeDialog(false);
                showMessage('success', 'Challenge escalated');
            });
    }

    return (
        <ValidatorForm onSubmit={handleSubmit}>
            <Grid
                container
                size={12}
                height={!scorecardViewModel ? "100px" : view === UserType.TeamLeader ? "390px" : "380px"}
                width="100%"
                overflow="hidden"
                spacing={1}
                paddingRight={2}
                paddingLeft={2}>
                {
                    loading ?
                        <Grid container justifyContent="center" alignItems="center" size={12} padding="40%" sx={{ height: "100%" }}>
                            <Grid>
                                <CircularProgress size={50} />
                            </Grid>
                        </Grid>
                        :
                        <ChallengeQuestionForm
                            view={view}
                            setOpenChallengeDialog={setOpenChallengeDialog}
                            challengeViewModel={challengeViewModel}
                            setChallengeViewModel={setChallengeViewModel}
                            scorecardViewModel={scorecardViewModel}
                        />
                }
            </Grid>
        </ValidatorForm>
    )
}